import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import TableCoversByFolder from '@/modules/tableCovers/TableCoversByFolder'
import TableCoversByKeyword from '@/modules/tableCovers/TableCoversByKeyword'
import { fetchFolderThunk, folderSelectors } from '@/redux/slices/folderSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { androidHeaderSearchBarThemeProps } from '@/theme'
import { useTheme } from 'expo-router/react-navigation'
import { Stack, useLocalSearchParams } from 'expo-router'
import Head from 'expo-router/head'
import { debounce } from 'lodash-es'
import { useEffect, useMemo, useState } from 'react'
import { Platform } from 'react-native'

export default function TableFolderPage() {
  const theme = useTheme()
  const { folderToken } = useLocalSearchParams<{ folderToken: string }>()
  const dispatch = useAppDispatch()
  const headerLeftItems = useWebBackButton('/tables')

  const folderName = useAppSelector(state => folderSelectors.selectById(state, folderToken)?.name)

  const [searchKeyword, setSearchKeyword] = useState<string | undefined>(undefined)

  useEffect(() => {
    dispatch(fetchFolderThunk({ folderToken }))
  }, [dispatch, folderToken])

  const handleSearchDebounced = useMemo(() => debounce(setSearchKeyword, 500), [setSearchKeyword])

  return (
    <>
      {Platform.OS === 'web' && folderName && (
        <Head>
          <title>{folderName}</title>
        </Head>
      )}
      <Stack.Screen
        options={{
          title: folderName ?? '',
          ...buildScreenHeaderItems({
            left: headerLeftItems,
          }),
          headerSearchBarOptions: {
            placement: 'automatic',
            placeholder: '搜索表格',
            ...androidHeaderSearchBarThemeProps(theme),
            onChangeText: ({ nativeEvent }) => {
              handleSearchDebounced(nativeEvent.text)
            },
          },
        }}
      />

      {searchKeyword ? (
        <TableCoversByKeyword keyword={searchKeyword} />
      ) : (
        <TableCoversByFolder folderToken={folderToken} />
      )}
    </>
  )
}
